import { ThemesColors } from './ThemesColors'
export const ThemesProperties = [
  {
    themeName: 'Theme-1',
    themeLight: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-1-light.jpg',
      themeColors: {
        primary: ThemesColors.Orange_500,
        onPrimary: ThemesColors.Neutrals_100,
        primaryContainer: ThemesColors.Orange_600,
        onPrimaryContainer: ThemesColors.Blue_100,
        secondary: ThemesColors.Yellow_500,
        onSecondary: ThemesColors.Neutrals_100,
        secondaryContainer: ThemesColors.Orange_200,
        onSecondaryContainer: ThemesColors.Orange_500,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Neutrals_000,
        backgroundVarient: ThemesColors.Orange_100,
        onBackground: ThemesColors.Neutrals_900,
        onBackgroundVarient: ThemesColors.Orange_500,
        backgroundContainer: ThemesColors.Neutrals_100,
        onBackgroundContainer: ThemesColors.Neutrals_900,
        surface: ThemesColors.Neutrals_100,
        onSurface: ThemesColors.Neutrals_900,
        surfaceVarient: ThemesColors.Orange_100,
        onSurfaceVarient: ThemesColors.Orange_700,
        outline: ThemesColors.Orange_400,
        outlineVarient: ThemesColors.Orange_300,
        outlineNeutral: ThemesColors.Neutrals_200,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Bebas Neue',
        bodyFont: 'Roboto'
      },
      themeStyles: {
        titleColor: ThemesColors.Orange_500,
        headingColor: ThemesColors.Orange_500,
        subHeadingColor: ThemesColors.Orange_500,
        subHeadingOnLayColor: ThemesColors.Orange_500,
        normalTextColor: ThemesColors.Neutrals_900,
        selectionColor: ThemesColors.Orange_500,
        selectionTextColor: ThemesColors.Neutrals_100
      }
    },
    themeDark: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-1-dark.jpg',
      themeColors: {
        primary: ThemesColors.Orange_500,
        onPrimary: ThemesColors.Orange_100,
        primaryContainer: ThemesColors.Orange_500,
        onPrimaryContainer: ThemesColors.Orange_700,
        secondary: ThemesColors.Yellow_500,
        onSecondary: ThemesColors.Yellow_100,
        secondaryContainer: ThemesColors.Neutrals_800,
        onSecondaryContainer: ThemesColors.Neutrals_100,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Neutrals_900,
        backgroundVarient: ThemesColors.Neutrals_900,
        onBackground: ThemesColors.Orange_100,
        onBackgroundVarient: ThemesColors.Orange_400,
        backgroundContainer: ThemesColors.Neutrals_800,
        onBackgroundContainer: ThemesColors.Neutrals_000,
        surface: ThemesColors.Neutrals_800,
        onSurface: ThemesColors.Neutrals_100,
        surfaceVarient: ThemesColors.Neutrals_800,
        onSurfaceVarient: ThemesColors.Neutrals_100,
        outline: ThemesColors.Neutrals_700,
        outlineVarient: ThemesColors.Orange_400,
        outlineNeutral: ThemesColors.Neutrals_800,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Bebas Neue',
        bodyFont: 'Roboto'
      },
      themeStyles: {
        titleColor: ThemesColors.Orange_500,
        headingColor: ThemesColors.Orange_500,
        subHeadingColor: ThemesColors.Orange_500,
        subHeadingOnLayColor: ThemesColors.Orange_500,
        normalTextColor: ThemesColors.Orange_100,
        selectionColor: ThemesColors.Orange_500,
        selectionTextColor: ThemesColors.Orange_100
      }
    }
  },
  {
    themeName: 'Theme-2',
    themeLight: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-2-light.jpg',
      themeColors: {
        primary: ThemesColors.Purple_700,
        onPrimary: ThemesColors.Neutrals_000,
        primaryContainer: ThemesColors.Purple_500,
        onPrimaryContainer: ThemesColors.Purple_100,
        secondary: ThemesColors.HotPink_500,
        onSecondary: ThemesColors.Neutrals_100,
        secondaryContainer: ThemesColors.HotPink_800,
        onSecondaryContainer: ThemesColors.HotPink_300,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Neutrals_000,
        backgroundVarient: ThemesColors.Blue_100,
        onBackground: ThemesColors.Neutrals_900,
        onBackgroundVarient: ThemesColors.Blue_500,
        backgroundContainer: ThemesColors.Neutrals_100,
        onBackgroundContainer: ThemesColors.Neutrals_900,
        surface: ThemesColors.Neutrals_100,
        onSurface: ThemesColors.Neutrals_900,
        surfaceVarient: ThemesColors.Blue_100,
        onSurfaceVarient: ThemesColors.Blue_600,
        outline: ThemesColors.Blue_200,
        outlineVarient: ThemesColors.HotPink_500,
        outlineNeutral: ThemesColors.Neutrals_200,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Poppins',
        bodyFont: 'Poppins'
      },
      themeStyles: {
        titleColor: ThemesColors.Purple_700,
        headingColor: ThemesColors.Purple_700,
        subHeadingColor: ThemesColors.Purple_700,
        subHeadingOnLayColor: ThemesColors.Purple_700,
        normalTextColor: ThemesColors.Neutrals_900,
        selectionColor: ThemesColors.Purple_700,
        selectionTextColor: ThemesColors.Neutrals_000
      }
    },
    themeDark: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-2-dark.jpg',
      themeColors: {
        primary: ThemesColors.HotPink_600,
        onPrimary: ThemesColors.HotPink_100,
        primaryContainer: ThemesColors.Purple_600,
        onPrimaryContainer: ThemesColors.Purple_100,
        secondary: ThemesColors.Neutrals_000,
        onSecondary: ThemesColors.HotPink_500,
        secondaryContainer: ThemesColors.HotPink_200,
        onSecondaryContainer: ThemesColors.HotPink_800,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Purple_800,
        backgroundVarient: ThemesColors.Purple_500,
        onBackground: ThemesColors.Purple_100,
        onBackgroundVarient: ThemesColors.Blue_100,
        backgroundContainer: ThemesColors.Purple_700,
        onBackgroundContainer: ThemesColors.Neutrals_000,
        surface: ThemesColors.Purple_700,
        onSurface: ThemesColors.Purple_100,
        surfaceVarient: ThemesColors.Purple_700,
        onSurfaceVarient: ThemesColors.Purple_100,
        outline: ThemesColors.Purple_600,
        outlineVarient: ThemesColors.HotPink_400,
        outlineNeutral: ThemesColors.Neutrals_800,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Poppins',
        bodyFont: 'Poppins'
      },
      themeStyles: {
        titleColor: ThemesColors.HotPink_100,
        headingColor: ThemesColors.HotPink_100,
        subHeadingColor: ThemesColors.HotPink_100,
        subHeadingOnLayColor: ThemesColors.HotPink_600,
        normalTextColor: ThemesColors.Purple_100,
        selectionColor: ThemesColors.HotPink_600,
        selectionTextColor: ThemesColors.HotPink_100
      }
    }
  },
  {
    themeName: 'Theme-3',
    themeLight: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-3-light.jpg',
      themeColors: {
        primary: ThemesColors.Blue_500,
        onPrimary: ThemesColors.Neutrals_100,
        primaryContainer: ThemesColors.Blue_600,
        onPrimaryContainer: ThemesColors.Blue_100,
        secondary: ThemesColors.Blue_400,
        onSecondary: ThemesColors.Neutrals_100,
        secondaryContainer: ThemesColors.Blue_100,
        onSecondaryContainer: ThemesColors.Blue_500,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Neutrals_000,
        backgroundVarient: ThemesColors.Blue_100,
        onBackground: ThemesColors.Neutrals_900,
        onBackgroundVarient: ThemesColors.Blue_500,
        backgroundContainer: ThemesColors.Neutrals_100,
        onBackgroundContainer: ThemesColors.Neutrals_900,
        surface: ThemesColors.Neutrals_100,
        onSurface: ThemesColors.Neutrals_900,
        surfaceVarient: ThemesColors.Blue_100,
        onSurfaceVarient: ThemesColors.Blue_600,
        outline: ThemesColors.Blue_200,
        outlineVarient: ThemesColors.Neutrals_400,
        outlineNeutral: ThemesColors.Neutrals_200,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Inter',
        bodyFont: 'Inter'
      },
      themeStyles: {
        titleColor: ThemesColors.Blue_500,
        headingColor: ThemesColors.Blue_500,
        subHeadingColor: ThemesColors.Blue_500,
        subHeadingOnLayColor: ThemesColors.Blue_500,
        normalTextColor: ThemesColors.Neutrals_900,
        selectionColor: ThemesColors.Blue_500,
        selectionTextColor: ThemesColors.Neutrals_100
      }
    },
    themeDark: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-3-dark.jpg',
      themeColors: {
        primary: ThemesColors.Blue_100,
        onPrimary: ThemesColors.Blue_500,
        primaryContainer: ThemesColors.Blue_800,
        onPrimaryContainer: ThemesColors.Blue_100,
        secondary: ThemesColors.Neutrals_000,
        onSecondary: ThemesColors.Blue_600,
        secondaryContainer: ThemesColors.Blue_700,
        onSecondaryContainer: ThemesColors.Blue_100,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Blue_600,
        backgroundVarient: ThemesColors.Blue_800,
        onBackground: ThemesColors.Blue_100,
        onBackgroundVarient: ThemesColors.Blue_100,
        backgroundContainer: ThemesColors.Blue_700,
        onBackgroundContainer: ThemesColors.Neutrals_000,
        surface: ThemesColors.Blue_700,
        onSurface: ThemesColors.Blue_100,
        surfaceVarient: ThemesColors.Blue_500,
        onSurfaceVarient: ThemesColors.Blue_100,
        outline: ThemesColors.Blue_400,
        outlineVarient: ThemesColors.Blue_500,
        outlineNeutral: ThemesColors.Neutrals_800,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Inter',
        bodyFont: 'Inter'
      },
      themeStyles: {
        titleColor: ThemesColors.Blue_100,
        headingColor: ThemesColors.Blue_100,
        subHeadingColor: ThemesColors.Blue_100,
        subHeadingOnLayColor: ThemesColors.Blue_100,
        normalTextColor: ThemesColors.Blue_100,
        selectionColor: ThemesColors.Blue_100,
        selectionTextColor: ThemesColors.Blue_500
      }
    }
  },
  {
    themeName: 'Theme-4',
    themeLight: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-4-light.jpg',
      themeColors: {
        primary: ThemesColors.Teal_800,
        onPrimary: ThemesColors.Neutrals_100,
        primaryContainer: ThemesColors.Teal_800,
        onPrimaryContainer: ThemesColors.Teal_100,
        secondary: ThemesColors.Salmon_500,
        onSecondary: ThemesColors.Neutrals_100,
        secondaryContainer: ThemesColors.Salmon_300,
        onSecondaryContainer: ThemesColors.Salmon_600,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Teal_100,
        backgroundVarient: ThemesColors.Teal_100,
        onBackground: ThemesColors.Neutrals_900,
        onBackgroundVarient: ThemesColors.Teal_800,
        backgroundContainer: ThemesColors.Teal_100,
        onBackgroundContainer: ThemesColors.Teal_900,
        surface: ThemesColors.Teal_100,
        onSurface: ThemesColors.Teal_900,
        surfaceVarient: ThemesColors.Teal_100,
        onSurfaceVarient: ThemesColors.Teal_800,
        outline: ThemesColors.Teal_800,
        outlineVarient: ThemesColors.Teal_700,
        outlineNeutral: ThemesColors.Neutrals_200,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Kalam',
        bodyFont: 'Poppins'
      },
      themeStyles: {
        titleColor: ThemesColors.Teal_800,
        headingColor: ThemesColors.Teal_800,
        subHeadingColor: ThemesColors.Teal_800,
        subHeadingOnLayColor: ThemesColors.Teal_800,
        normalTextColor: ThemesColors.Neutrals_900,
        selectionColor: ThemesColors.Teal_800,
        selectionTextColor: ThemesColors.Neutrals_100
      }
    },
    themeDark: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-4-dark.jpg',
      themeColors: {
        primary: ThemesColors.Neutrals_000,
        onPrimary: ThemesColors.Teal_800,
        primaryContainer: ThemesColors.Teal_100,
        onPrimaryContainer: ThemesColors.Teal_600,
        secondary: ThemesColors.Neutrals_000,
        onSecondary: ThemesColors.Salmon_600,
        secondaryContainer: ThemesColors.Salmon_600,
        onSecondaryContainer: ThemesColors.Salmon_300,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Teal_800,
        backgroundVarient: ThemesColors.Teal_900,
        onBackground: ThemesColors.Neutrals_000,
        onBackgroundVarient: ThemesColors.Teal_100,
        backgroundContainer: ThemesColors.Teal_800,
        onBackgroundContainer: ThemesColors.Neutrals_000,
        surface: ThemesColors.Teal_800,
        onSurface: ThemesColors.Neutrals_100,
        surfaceVarient: ThemesColors.Teal_900,
        onSurfaceVarient: ThemesColors.Neutrals_100,
        outline: ThemesColors.Teal_100,
        outlineVarient: ThemesColors.Teal_700,
        outlineNeutral: ThemesColors.Neutrals_800,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Kalam',
        bodyFont: 'Poppins'
      },
      themeStyles: {
        titleColor: ThemesColors.Neutrals_000,
        headingColor: ThemesColors.Neutrals_000,
        subHeadingColor: ThemesColors.Neutrals_000,
        subHeadingOnLayColor: ThemesColors.Neutrals_000,
        normalTextColor: ThemesColors.Neutrals_000,
        selectionColor: ThemesColors.Neutrals_000,
        selectionTextColor: ThemesColors.Teal_800
      }
    }
  },
  {
    themeName: 'Theme-5',
    themeLight: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-5-light.jpg',
      themeColors: {
        primary: ThemesColors.HotPink_500,
        onPrimary: ThemesColors.Neutrals_100,
        primaryContainer: ThemesColors.HotPink_600,
        onPrimaryContainer: ThemesColors.HotPink_200,
        secondary: ThemesColors.Salmon_500,
        onSecondary: ThemesColors.Neutrals_100,
        secondaryContainer: ThemesColors.Salmon_300,
        onSecondaryContainer: ThemesColors.Neutrals_000,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Salmon_100,
        backgroundVarient: ThemesColors.HotPink_500,
        onBackground: ThemesColors.Neutrals_800,
        onBackgroundVarient: ThemesColors.Neutrals_000,
        backgroundContainer: ThemesColors.Salmon_100,
        onBackgroundContainer: ThemesColors.Neutrals_900,
        surface: ThemesColors.Salmon_100,
        onSurface: ThemesColors.Neutrals_900,
        surfaceVarient: ThemesColors.Salmon_100,
        onSurfaceVarient: ThemesColors.Neutrals_800,
        outline: ThemesColors.Neutrals_400,
        outlineVarient: ThemesColors.Salmon_500,
        outlineNeutral: ThemesColors.Neutrals_200,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Anodina',
        bodyFont: 'Inter'
      },
      themeStyles: {
        titleColor: 'linear-gradient(90deg, #FF5730 0%, #FF5198 100%)',
        headingColor: 'linear-gradient(90deg, #FF5730 0%, #FF5198 100%)',
        subHeadingColor: 'linear-gradient(90deg, #FF5730 0%, #FF5198 100%)',
        subHeadingOnLayColor:
          'linear-gradient(90deg, #FF5730 0%, #FF5198 100%)',
        normalTextColor: ThemesColors.Neutrals_800,
        selectionColor: 'linear-gradient(90deg, #FF5730 0%, #FF5198 100%)',
        selectionTextColor: ThemesColors.Neutrals_100
      }
    },
    themeDark: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-5-dark.jpg',
      themeColors: {
        primary: ThemesColors.Neutrals_300,
        onPrimary: ThemesColors.Neutrals_000,
        primaryContainer: ThemesColors.Neutrals_800,
        onPrimaryContainer: ThemesColors.Neutrals_000,
        secondary: ThemesColors.Neutrals_000,
        onSecondary: ThemesColors.Salmon_800,
        secondaryContainer: ThemesColors.Salmon_600,
        onSecondaryContainer: ThemesColors.Neutrals_000,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Neutrals_900,
        backgroundVarient: ThemesColors.Neutrals_800,
        onBackground: ThemesColors.Neutrals_000,
        onBackgroundVarient: ThemesColors.HotPink_500,
        backgroundContainer: ThemesColors.Neutrals_800,
        onBackgroundContainer: ThemesColors.Neutrals_000,
        surface: ThemesColors.Neutrals_800,
        onSurface: ThemesColors.Neutrals_100,
        surfaceVarient: ThemesColors.Neutrals_800,
        onSurfaceVarient: ThemesColors.Neutrals_100,
        outline: ThemesColors.Neutrals_700,
        outlineVarient: ThemesColors.Salmon_500,
        outlineNeutral: ThemesColors.Neutrals_800,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Anodina',
        bodyFont: 'Inter'
      },
      themeStyles: {
        titleColor: 'linear-gradient(90deg, #FF5730 0%, #FF5198 100%)',
        headingColor: 'linear-gradient(90deg, #FF5730 0%, #FF5198 100%)',
        subHeadingColor: 'linear-gradient(90deg, #FF5730 0%, #FF5198 100%)',
        subHeadingOnLayColor:
          'linear-gradient(90deg, #FF5730 0%, #FF5198 100%)',
        normalTextColor: ThemesColors.Neutrals_000,
        selectionColor: 'linear-gradient(90deg, #FF5730 0%, #FF5198 100%)',
        selectionTextColor: ThemesColors.Neutrals_000
      }
    }
  },
  {
    themeName: 'Theme-6',
    themeLight: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-6-light.jpg',
      themeColors: {
        primary: ThemesColors.DustyBrown_700,
        onPrimary: ThemesColors.Neutrals_100,
        primaryContainer: ThemesColors.DustyBrown_500,
        onPrimaryContainer: ThemesColors.Neutrals_100,
        secondary: ThemesColors.Neutrals_400,
        onSecondary: ThemesColors.Neutrals_100,
        secondaryContainer: ThemesColors.DustyBrown_400,
        onSecondaryContainer: ThemesColors.DustyBrown_800,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.DustyBrown_100,
        backgroundVarient: ThemesColors.DustyBrown_600,
        onBackground: ThemesColors.DustyBrown_800,
        onBackgroundVarient: ThemesColors.DustyBrown_100,
        backgroundContainer: ThemesColors.DustyBrown_100,
        onBackgroundContainer: ThemesColors.DustyBrown_800,
        surface: ThemesColors.DustyBrown_100,
        onSurface: ThemesColors.DustyBrown_800,
        surfaceVarient: ThemesColors.DustyBrown_100,
        onSurfaceVarient: ThemesColors.DustyBrown_800,
        outline: ThemesColors.DustyBrown_300,
        outlineVarient: ThemesColors.DustyBrown_400,
        outlineNeutral: ThemesColors.Neutrals_200,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Playfair Display',
        bodyFont: 'Crimson Text'
      },
      themeStyles: {
        titleColor: ThemesColors.DustyBrown_700,
        headingColor: ThemesColors.DustyBrown_700,
        subHeadingColor: ThemesColors.DustyBrown_700,
        subHeadingOnLayColor: ThemesColors.DustyBrown_700,
        normalTextColor: ThemesColors.DustyBrown_800,
        selectionColor: ThemesColors.DustyBrown_700,
        selectionTextColor: ThemesColors.Neutrals_100
      }
    },
    themeDark: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-6-dark.jpg',
      themeColors: {
        primary: ThemesColors.DustyBrown_100,
        onPrimary: ThemesColors.DustyBrown_900,
        primaryContainer: ThemesColors.DustyBrown_500,
        onPrimaryContainer: ThemesColors.Neutrals_100,
        secondary: ThemesColors.DustyBrown_100,
        onSecondary: ThemesColors.DustyBrown_600,
        secondaryContainer: ThemesColors.DustyBrown_400,
        onSecondaryContainer: ThemesColors.DustyBrown_900,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.DustyBrown_800,
        backgroundVarient: ThemesColors.DustyBrown_100,
        onBackground: ThemesColors.Neutrals_000,
        onBackgroundVarient: ThemesColors.DustyBrown_900,
        backgroundContainer: ThemesColors.DustyBrown_700,
        onBackgroundContainer: ThemesColors.DustyBrown_100,
        surface: ThemesColors.DustyBrown_900,
        onSurface: ThemesColors.Blue_100,
        surfaceVarient: ThemesColors.DustyBrown_700,
        onSurfaceVarient: ThemesColors.Blue_100,
        outline: ThemesColors.DustyBrown_600,
        outlineVarient: ThemesColors.DustyBrown_600,
        outlineNeutral: ThemesColors.Neutrals_800,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Playfair Display',
        bodyFont: 'Crimson Text'
      },
      themeStyles: {
        titleColor: ThemesColors.DustyBrown_100,
        headingColor: ThemesColors.DustyBrown_100,
        subHeadingColor: ThemesColors.DustyBrown_100,
        subHeadingOnLayColor: ThemesColors.DustyBrown_100,
        normalTextColor: ThemesColors.Neutrals_000,
        selectionColor: ThemesColors.DustyBrown_100,
        selectionTextColor: ThemesColors.DustyBrown_900
      }
    }
  },
  {
    themeName: 'Theme-7',
    themeLight: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-7-light.jpg',
      themeColors: {
        primary: ThemesColors.Orange_500,
        onPrimary: ThemesColors.Orange_100,
        primaryContainer: ThemesColors.Orange_600,
        onPrimaryContainer: ThemesColors.Orange_200,
        secondary: ThemesColors.Orange_500,
        onSecondary: ThemesColors.Neutrals_100,
        secondaryContainer: ThemesColors.Orange_200,
        onSecondaryContainer: ThemesColors.Orange_500,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Orange_100,
        backgroundVarient: ThemesColors.Orange_100,
        onBackground: ThemesColors.Neutrals_800,
        onBackgroundVarient: ThemesColors.Orange_500,
        backgroundContainer: ThemesColors.Orange_100,
        onBackgroundContainer: ThemesColors.Neutrals_900,
        surface: ThemesColors.Orange_100,
        onSurface: ThemesColors.Neutrals_900,
        surfaceVarient: ThemesColors.Orange_200,
        onSurfaceVarient: ThemesColors.Neutrals_800,
        outline: ThemesColors.Orange_300,
        outlineVarient: ThemesColors.Orange_400,
        outlineNeutral: ThemesColors.Neutrals_200,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Montserrat',
        bodyFont: 'Montserrat'
      },
      themeStyles: {
        titleColor: ThemesColors.Orange_500,
        headingColor: ThemesColors.Orange_500,
        subHeadingColor: ThemesColors.Orange_500,
        subHeadingOnLayColor: ThemesColors.Orange_500,
        normalTextColor: ThemesColors.Neutrals_800,
        selectionColor: ThemesColors.Orange_500,
        selectionTextColor: ThemesColors.Orange_100
      }
    },
    themeDark: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-7-dark.jpg',
      themeColors: {
        primary: ThemesColors.Neutrals_000,
        onPrimary: ThemesColors.Orange_500,
        primaryContainer: ThemesColors.Orange_600,
        onPrimaryContainer: ThemesColors.Neutrals_000,
        secondary: ThemesColors.Neutrals_000,
        onSecondary: ThemesColors.Orange_500,
        secondaryContainer: ThemesColors.Orange_300,
        onSecondaryContainer: ThemesColors.Orange_700,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Orange_500,
        backgroundVarient: ThemesColors.Orange_600,
        onBackground: ThemesColors.Neutrals_000,
        onBackgroundVarient: ThemesColors.Orange_200,
        backgroundContainer: ThemesColors.Orange_400,
        onBackgroundContainer: ThemesColors.Orange_900,
        surface: ThemesColors.Orange_600,
        onSurface: ThemesColors.Neutrals_100,
        surfaceVarient: ThemesColors.Orange_500,
        onSurfaceVarient: ThemesColors.Neutrals_100,
        outline: ThemesColors.Orange_300,
        outlineVarient: ThemesColors.Orange_600,
        outlineNeutral: ThemesColors.Neutrals_800,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Montserrat',
        bodyFont: 'Montserrat'
      },
      themeStyles: {
        titleColor: ThemesColors.Neutrals_000,
        headingColor: ThemesColors.Neutrals_000,
        subHeadingColor: ThemesColors.Neutrals_000,
        subHeadingOnLayColor: ThemesColors.Neutrals_000,
        normalTextColor: ThemesColors.Neutrals_000,
        selectionColor: ThemesColors.Neutrals_000,
        selectionTextColor: ThemesColors.Orange_500
      }
    }
  },
  {
    themeName: 'Theme-8',
    themeLight: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-8-light.jpg',
      themeColors: {
        primary: ThemesColors.HotPink_300,
        onPrimary: ThemesColors.Neutrals_000,
        primaryContainer: ThemesColors.Neutrals_600,
        onPrimaryContainer: ThemesColors.Neutrals_100,
        secondary: ThemesColors.Neutrals_400,
        onSecondary: ThemesColors.Neutrals_100,
        secondaryContainer: ThemesColors.WashedGreen_500,
        onSecondaryContainer: ThemesColors.Neutrals_000,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Neutrals_000,
        backgroundVarient: ThemesColors.Neutrals_000,
        onBackground: ThemesColors.Neutrals_700,
        onBackgroundVarient: ThemesColors.HotPink_300,
        backgroundContainer: ThemesColors.Neutrals_000,
        onBackgroundContainer: ThemesColors.Neutrals_800,
        surface: ThemesColors.Neutrals_000,
        onSurface: ThemesColors.Neutrals_900,
        surfaceVarient: ThemesColors.Success_100,
        onSurfaceVarient: ThemesColors.Neutrals_900,
        outline: ThemesColors.WashedGreen_200,
        outlineVarient: ThemesColors.HotPink_200,
        outlineNeutral: ThemesColors.Neutrals_200,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Nunito',
        bodyFont: 'Montserrat'
      },
      themeStyles: {
        titleColor: ThemesColors.HotPink_300,
        headingColor: ThemesColors.HotPink_300,
        subHeadingColor: ThemesColors.HotPink_300,
        subHeadingOnLayColor: ThemesColors.HotPink_300,
        normalTextColor: ThemesColors.Neutrals_700,
        selectionColor: ThemesColors.HotPink_300,
        selectionTextColor: ThemesColors.Neutrals_000
      }
    },
    themeDark: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-8-dark.jpg',
      themeColors: {
        primary: ThemesColors.Yellow_300,
        onPrimary: ThemesColors.WashedGreen_600,
        primaryContainer: ThemesColors.WashedGreen_700,
        onPrimaryContainer: ThemesColors.Neutrals_100,
        secondary: ThemesColors.WashedGreen_100,
        onSecondary: ThemesColors.WashedGreen_600,
        secondaryContainer: ThemesColors.Yellow_300,
        onSecondaryContainer: ThemesColors.WashedGreen_600,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.WashedGreen_700,
        backgroundVarient: ThemesColors.WashedGreen_800,
        onBackground: ThemesColors.Neutrals_000,
        onBackgroundVarient: ThemesColors.Yellow_300,
        backgroundContainer: ThemesColors.WashedGreen_600,
        onBackgroundContainer: ThemesColors.Neutrals_100,
        surface: ThemesColors.WashedGreen_800,
        onSurface: ThemesColors.Neutrals_000,
        surfaceVarient: ThemesColors.WashedGreen_600,
        onSurfaceVarient: ThemesColors.Neutrals_000,
        outline: ThemesColors.WashedGreen_500,
        outlineVarient: ThemesColors.WashedGreen_500,
        outlineNeutral: ThemesColors.Neutrals_800,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Nunito',
        bodyFont: 'Montserrat'
      },
      themeStyles: {
        titleColor: ThemesColors.Yellow_300,
        headingColor: ThemesColors.Yellow_300,
        subHeadingColor: ThemesColors.Yellow_300,
        subHeadingOnLayColor: ThemesColors.Yellow_300,
        normalTextColor: ThemesColors.Neutrals_000,
        selectionColor: ThemesColors.Yellow_300,
        selectionTextColor: ThemesColors.WashedGreen_600
      }
    }
  },
  {
    themeName: 'Theme-9',
    themeLight: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-9-light.jpg',
      themeColors: {
        primary: ThemesColors.Neutrals_1000,
        onPrimary: ThemesColors.Neutrals_100,
        primaryContainer: ThemesColors.Blue_200,
        onPrimaryContainer: ThemesColors.Neutrals_800,
        secondary: ThemesColors.Teal_600,
        onSecondary: ThemesColors.Neutrals_000,
        secondaryContainer: ThemesColors.Purple_100,
        onSecondaryContainer: ThemesColors.Purple_300,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Neutrals_000,
        backgroundVarient: ThemesColors.Purple_100,
        onBackground: ThemesColors.Neutrals_800,
        onBackgroundVarient: ThemesColors.Purple_300,
        backgroundContainer: ThemesColors.Neutrals_000,
        onBackgroundContainer: ThemesColors.Neutrals_900,
        surface: ThemesColors.Neutrals_100,
        onSurface: ThemesColors.Neutrals_900,
        surfaceVarient: ThemesColors.Neutrals_000,
        onSurfaceVarient: ThemesColors.Neutrals_900,
        outline: ThemesColors.Purple_200,
        outlineVarient: ThemesColors.Teal_500,
        outlineNeutral: ThemesColors.Neutrals_200,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Space Grotesk',
        bodyFont: 'Space Grotesk'
      },
      themeStyles: {
        titleColor: ThemesColors.Neutrals_1000,
        headingColor: ThemesColors.Neutrals_1000,
        subHeadingColor: ThemesColors.Neutrals_1000,
        subHeadingOnLayColor: ThemesColors.Neutrals_1000,
        normalTextColor: ThemesColors.Neutrals_800,
        selectionColor: ThemesColors.Teal_600,
        selectionTextColor: ThemesColors.Neutrals_000
      }
    },
    themeDark: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-9-dark.jpg',
      themeColors: {
        primary: ThemesColors.Neutrals_000,
        onPrimary: ThemesColors.Neutrals_900,
        primaryContainer: ThemesColors.Purple_500,
        onPrimaryContainer: ThemesColors.Neutrals_000,
        secondary: ThemesColors.Teal_600,
        onSecondary: ThemesColors.Teal_300,
        secondaryContainer: ThemesColors.Purple_400,
        onSecondaryContainer: ThemesColors.Purple_100,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Neutrals_1000,
        backgroundVarient: ThemesColors.Neutrals_900,
        onBackground: ThemesColors.Neutrals_000,
        onBackgroundVarient: ThemesColors.Neutrals_100,
        backgroundContainer: ThemesColors.Neutrals_1000,
        onBackgroundContainer: ThemesColors.Neutrals_000,
        surface: ThemesColors.Neutrals_900,
        onSurface: ThemesColors.Neutrals_000,
        surfaceVarient: ThemesColors.Neutrals_900,
        onSurfaceVarient: ThemesColors.Neutrals_000,
        outline: ThemesColors.Neutrals_800,
        outlineVarient: ThemesColors.Teal_300,
        outlineNeutral: ThemesColors.Neutrals_800,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Space Grotesk',
        bodyFont: 'Space Grotesk'
      },
      themeStyles: {
        titleColor: ThemesColors.Neutrals_000,
        headingColor: ThemesColors.Neutrals_000,
        subHeadingColor: ThemesColors.Neutrals_000,
        subHeadingOnLayColor: ThemesColors.Neutrals_000,
        normalTextColor: ThemesColors.Neutrals_000,
        selectionColor: ThemesColors.Teal_600,
        selectionTextColor: ThemesColors.Teal_300
      }
    }
  },
  {
    themeName: 'Theme-10',
    themeLight: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-10-light.jpg',
      themeColors: {
        primary: ThemesColors.Red_500,
        onPrimary: ThemesColors.Neutrals_000,
        primaryContainer: ThemesColors.Neutrals_800,
        onPrimaryContainer: ThemesColors.Neutrals_100,
        secondary: ThemesColors.Neutrals_400,
        onSecondary: ThemesColors.Neutrals_100,
        secondaryContainer: ThemesColors.Red_500,
        onSecondaryContainer: ThemesColors.Neutrals_000,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Neutrals_000,
        backgroundVarient: ThemesColors.Neutrals_000,
        onBackground: ThemesColors.Neutrals_1000,
        onBackgroundVarient: ThemesColors.Red_500,
        backgroundContainer: ThemesColors.Neutrals_000,
        onBackgroundContainer: ThemesColors.Neutrals_1000,
        surface: ThemesColors.Neutrals_000,
        onSurface: ThemesColors.Neutrals_900,
        surfaceVarient: ThemesColors.Neutrals_100,
        onSurfaceVarient: ThemesColors.Neutrals_900,
        outline: ThemesColors.Neutrals_200,
        outlineVarient: ThemesColors.Red_500,
        outlineNeutral: ThemesColors.Neutrals_200,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Rubik',
        bodyFont: 'Nunito'
      },
      themeStyles: {
        titleColor: ThemesColors.Red_500,
        headingColor: ThemesColors.Red_500,
        subHeadingColor: ThemesColors.Red_500,
        subHeadingOnLayColor: ThemesColors.Red_500,
        normalTextColor: ThemesColors.Neutrals_1000,
        selectionColor: ThemesColors.Red_500,
        selectionTextColor: ThemesColors.Neutrals_000
      }
    },
    themeDark: {
      themeImage:
        'https://learnpodseditornodeserver.knomadixapp.com/Smart-Canvas/themes-bg/Theme-10-dark.jpg',
      themeColors: {
        primary: ThemesColors.Neutrals_000,
        onPrimary: ThemesColors.Red_500,
        primaryContainer: ThemesColors.Neutrals_900,
        onPrimaryContainer: ThemesColors.Neutrals_100,
        secondary: ThemesColors.Neutrals_000,
        onSecondary: ThemesColors.Neutrals_600,
        secondaryContainer: ThemesColors.Red_500,
        onSecondaryContainer: ThemesColors.Neutrals_000,
        error: ThemesColors.Error_500,
        onError: ThemesColors.Neutrals_100,
        errorContainer: ThemesColors.Error_600,
        onErrorContainer: ThemesColors.Error_200,
        success: ThemesColors.Success_500,
        onSuccess: ThemesColors.Neutrals_100,
        successContainer: ThemesColors.Success_600,
        onSuccessContainer: ThemesColors.Success_400,
        background: ThemesColors.Neutrals_1000,
        backgroundVarient: ThemesColors.Red_500,
        onBackground: ThemesColors.Neutrals_000,
        onBackgroundVarient: ThemesColors.Neutrals_000,
        backgroundContainer: ThemesColors.Neutrals_1000,
        onBackgroundContainer: ThemesColors.Neutrals_000,
        surface: ThemesColors.Neutrals_1000,
        onSurface: ThemesColors.Neutrals_000,
        surfaceVarient: ThemesColors.Neutrals_800,
        onSurfaceVarient: ThemesColors.Neutrals_000,
        outline: ThemesColors.Neutrals_700,
        outlineVarient: ThemesColors.Red_500,
        outlineNeutral: ThemesColors.Neutrals_800,
        overlayHard: ThemesColors.Overlays_700,
        overlaySoft: ThemesColors.Overlays_200
      },
      themeFont: {
        displayFont: 'Rubik',
        bodyFont: 'Nunito'
      },
      themeStyles: {
        titleColor: ThemesColors.Neutrals_000,
        headingColor: ThemesColors.Neutrals_000,
        subHeadingColor: ThemesColors.Neutrals_000,
        subHeadingOnLayColor: ThemesColors.Neutrals_000,
        normalTextColor: ThemesColors.Neutrals_000,
        selectionColor: ThemesColors.Neutrals_000,
        selectionTextColor: ThemesColors.Red_500
      }
    }
  }
]
